import { RouteObject } from 'react-router-dom';
export const adminRoutes: RouteObject[] = [
  {
    lazy: async () => ({
      Component: (await import('@app/router/hocs'))
        .AdminProtectedRoute,
    }),
    path: 'admin',
    children: [
      {
        path: 'dashboard',
        lazy: async () => ({
          Component: (await import('@pages/dashboard')).DashboardPage,
        }),
      },
      {
        path: 'users-management',
        lazy: async () => ({
          Component: (await import('@pages/users-management'))
            .UsersManagementPage,
        }),
      },
      {
        path: 'trainer-signup',
        lazy: async () => ({
          Component: (await import('@pages/trainer-signup')).TrainerSignUpPage,
        }),
      },
      {
        path: 'analytics',
        lazy: async () => ({
          Component: (await import('@pages/analytics')).AnalyticsPage,
        }),
      },
      {
        path: 'admin-create-user',
        lazy: async () => ({
          Component: (await import('@pages/admin-create-user')).AdminCreateUser,
        }),
      },
      {
        path: 'event-calendar',
        lazy: async () => ({
          Component: (await import('@pages/event-calendar')).EventCalendarPage,
        }),
      },
      {
        path: 'event-management',
        lazy: async () => ({
          Component: (await import('@pages/event-management'))
            .EventManagementPage,
        }),
      },
    ],
  },
];
